import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/Card'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import useLogout from '@/services/api/auth/useLogout'
import { LogOut, AlertTriangle } from 'lucide-react'

export default function LogoutSection() {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const { logout, logoutStatus } = useLogout()

  const handleLogout = async () => {
    await logout()
    setShowConfirmDialog(false)
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="mb-2">Logout</h2>
        <p className="mb-4 text-gray-600">Securely end your current session.</p>
      </div>

      <Card className="border-red-200  bg-red-50 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <LogOut className="h-8 w-8 text-red-600" />
            <div>
              <div className="mb-1 text-red-900">End Session</div>
              <p className="text-sm text-red-700">
                This will log you out of your account on this device
              </p>
            </div>
          </div>
          <Button
            variant="destructiveOutline"
            onClick={() => setShowConfirmDialog(true)}
            className=""
          >
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </Button>
        </div>
      </Card>

      {/* Logout Confirmation Dialog */}
      <Dialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
              Confirm Logout
            </DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className="space-y-4">
              <div className="text-center">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                  <LogOut className="h-8 w-8 text-red-600" />
                </div>
                <p className="mb-4 text-gray-600">
                  Are you sure you want to logout? You'll need to sign in again
                  to access your account.
                </p>
              </div>

              <div className="flex gap-3">
                <Button
                  variant="destructive"
                  onClick={handleLogout}
                  disabled={logoutStatus.status === 'pending'}
                  className="flex-1"
                >
                  {logoutStatus.status === 'pending' ? (
                    'Logging out...'
                  ) : (
                    <>
                      <LogOut className="mr-2 h-4 w-4" />
                      Yes, Logout
                    </>
                  )}
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setShowConfirmDialog(false)}
                  disabled={logoutStatus.status === 'pending'}
                  className="flex-1"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </DialogBody>
        </DialogContent>
      </Dialog>
    </div>
  )
}
